import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Link,
  Box,
  Snackbar,
  Alert,
} from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import DateBasedChecklists from './DateBasedChecklists';
import AddUpcomingButton from './AddUpcomingButton';
import AddUpcomingModal from './AddUpcomingModal';

const NotionLinkOnly: React.FC = () => {
  const notionUrl = 'https://www.notion.so/Todo-Today-22f296896e13803bb9eee1e0b72eef54?pvs=12';
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [targetDate, setTargetDate] = useState<string | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('Date added successfully!');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'info'>('success');

  const handleModalSuccess = (date: string, alreadyExists?: boolean) => {
    // Store the date we want to expand and scroll to
    setTargetDate(date);
    // Trigger a refresh by updating the key
    setRefreshKey(prev => prev + 1);
    // Set appropriate message, severity, and show snackbar
    setSnackbarMessage(alreadyExists ? 'This date exists' : 'Date added successfully!');
    setSnackbarSeverity(alreadyExists ? 'info' : 'success');
    setSnackbarOpen(true);
  };

  const handleDateExpanded = () => {
    // Clear target date after expansion is complete
    setTargetDate(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Upcoming
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Link
            href={notionUrl}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              fontSize: '1.1rem',
              fontWeight: 500,
              color: 'primary.main',
              '&:hover': {
                color: 'primary.light',
              },
            }}
          >
            Notion
            <OpenInNewIcon fontSize="small" />
          </Link>
        </Box>

        <AddUpcomingButton onClick={() => setModalOpen(true)} />

        <DateBasedChecklists 
          key={refreshKey} 
          filterMode="future" 
          expandAndScrollToDate={targetDate}
          onDateExpanded={handleDateExpanded}
        />
      </CardContent>
    </Card>

    <AddUpcomingModal 
      open={modalOpen} 
      onClose={() => setModalOpen(false)}
      onSuccess={handleModalSuccess}
    />

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={3000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
        {snackbarMessage}
      </Alert>
    </Snackbar>
    </>
  );
};

export default NotionLinkOnly;
